<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ this.$route.query.id != null ? 'Edit' : 'Add' }} City</h1>
    </div>
    <div class="form-group">
      <div class="row px-3">
        <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Province</label>
        <select class="form-control col-lg-8" v-model="province">
          <option v-for="(data,index) in arr_province" :value="data.id" :key="index">{{ data.name }}</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <div class="row px-3">
        <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Name</label>
        <input class="form-control col-lg-8" id="form-name" v-model="name"/>
      </div>
    </div>
    <div class="form-group text-right">
      <a type="button" class="btn btn-danger" href="/master/city">Cancel</a>
      <button type="button" class="btn btn-primary" @click="save">Save</button>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
      name: '',
      province: '',
      arr_province: []
    }
  },
  created(){
    this.get_province()
    if(this.$route.query.id != null){

      this.get_data()
    }
  },
  methods:{
    async save(){
      try{
        if(this.selected_type == '')
          this.$toasted.show('Type is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          if(this.$route.query.id != null)
            data.id = this.$route.query.id
          data.name = this.name
          data.province = {
            id: this.province
          }

          if(this.$route.query.id == null)
            var response = await axios.post(base_url+'/city',data)
          else
            var response = await axios.put(base_url+'/city',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/master/city'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e)
      }
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/city?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.name = response_data.data.name
          this.province = response_data.data.province_id
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    async get_province(){
      try{
        var response = await axios.get(base_url+'/province/all')

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_province = response_data.data
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    }
  }
}
</script>
